export enum FlyoutDirection {
    Left = 'flyleft',
    Right = 'flyright',
    Down = 'flydown',
}
